import React from 'react'

const Checkout = () => {
  return (
    <div className="h-[80vh] w-100% flex align-middle justify-center items-center">
    <img
      src="https://i.ibb.co/QJxzDBM/Group-21-2.png"
      className="w-[100%] h-[100%] ml-28 object-contain bg-contain"
    />
  </div>
  )
}

export default Checkout
